module.exports = __webpack_public_path__ + "img/bg-dashboard-bluepurple.6c1c5e78.png";